import React,{useState} from 'react'
import { Dialog, DialogActions, DialogContent,  IconButton, Tooltip } from "@mui/material";
import { Delete, Warning } from '@mui/icons-material';


export default function ConfirmDelete({id, confirm,children}) {
    const [dialogStatus, setDialogStatus] = useState(false);
    const handleClose = () =>{
        setDialogStatus(false)
    }
    return (
    <>  
        
        <Tooltip title="Remove">
            <IconButton onClick={()=>setDialogStatus(true)} style={{padding:"0px"}} className="delete-icon ms-2">
                <Delete/>
            </IconButton>
        </Tooltip>
        
        <Dialog
                open={dialogStatus}
                keepMounted
                onClose={handleClose}
                fullWidth={true}
                maxWidth="md"
                aria-describedby="alert-dialog-slide-description"
        >

            <DialogContent> <Warning/> {children}</DialogContent>
            <DialogActions>
                <button type="button" onClick={()=>{confirm(id);handleClose()} } className="btn btn-danger">Yes</button>
                <button type="button" onClick={handleClose} className="btn btn-success">No</button>
            </DialogActions>
        </Dialog>
    </>
    )
}
